<template>
  <div class="stock-renovate-record-bd tb" v-if="funcView.stock_renovate_record_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <!-- 导出 -->
        <el-form-item v-if="funcView.stock_renovate_record_export" style="float: right" :class="{ 'mr-0': funcView.stock_renovate_record_export }">
          <el-button class="table-set" style="vertical-align: top" @click="exportTable('renovateRecordExport', formSearch)">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <el-form-item style="float: right" :class="{ 'mr-0': !funcView.stock_renovate_record_export }">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('dms_renovateRecord.ji_shen_hao')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('dms_renovateRecord.chan_pin_xing_hao')">
          <custom-select url="productCodeSelectList" v-model="formSearch.productCode" :props="{ label: 'productCode', value: 'productCode' }" width="100%"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('dms_renovateRecord.she_bei_lei_xing')">
          <custom-select v-model="formSearch.deviceBizType" code="dms_device_biz_type" :props="{ label: 'name', value: 'value' }" width="100%"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('dms_renovateRecord.xin_she_bei_lei_xing')">
          <custom-select v-model="formSearch.newDeviceBizType" code="dms_device_biz_type" :props="{ label: 'name', value: 'value' }" width="100%"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('dms_renovateRecord.fan_xin_shi_jian')">
          <custom-date-picker
            style="vertical-align: top"
            @change="onPageChange({ page: 1 })"
            v-model="dataTimes"
            type="daterange"
            :picker-options="pickerOption"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('dms_renovateRecord.fan_xin_ci_shu')">
          <el-input type="number" :min="0" v-model="formSearch.renovateNum" width="100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_renovateRecord.fan_xin_gong_si')">
          <el-input type="text"  v-model="formSearch.renovateOrgName" width="100%"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table ref="table" index height="100%" tableCode="renovate_record" :data="tableList" @filter="filterChange" @sort="sortChange" @column="setColumn"></custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  name: 'renovateRecord',
  components: {},
  data() {
    return {
      formSearch: {
        productCode: '',
        deviceBizType: '',
        renovateNum: undefined, // 翻新次数
        renovateStartTime: '',
        renovateEndTime: '',
        newDeviceBizType: '',
        renovateOrgName: '',
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
      },

      dataTimes: [],
      tableList: [],
      totalRows: null,

      dialogVisible: false,
      dialogModel: {},
      dialogData: {},
      link: null,
    };
  },
  activated: function () {
    this.getTableList();
  },
  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);

    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });
  },
  methods: {
    // 获取表格数据列表
    getTableList: function () {
      this.formSearch.renovateStartTime = this.dataTimes ? this.dataTimes[0] : '';
      this.formSearch.renovateEndTime = this.dataTimes ? this.dataTimes[1] : '';
      this.$getJSON(apis.renovateRecordPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 清除
    clearFilter: function () {
      this.dataTimes = [];
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.getTableList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'style/colors.scss';
</style>
